import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiPlus, FiBox } = FiIcons;

const stack = [
  {
    item: "หลักสูตร BAZI FINANCIAL & INVESTMENT 2 วันเต็ม",
    detail: "Workshop ลงมือทำจริง 19–20 กันยายน 2569",
    value: "12,900",
    isMain: true
  },
  {
    item: "Bonus: เอกสารสรุปสูตรและตารางคำนวณ",
    detail: "ฉบับพิมพ์สี พรีเมียมแมท นำกลับไปใช้งานได้ทันที",
    value: "2,500",
    isBonus: true
  },
  {
    item: "Bonus: เครื่องมือวิเคราะห์ BAZI FINANCIAL 20 รายการ",
    detail: "สิทธิ์การเข้าถึงระบบ Cloud วิเคราะห์ดวงการเงินระดับสูง",
    value: "4,000",
    isBonus: true
  },
  {
    item: "Bonus: อัพเกรด Bazi Master (3 เดือน)",
    detail: "ปลดล็อกฟีเจอร์วิเคราะห์พอร์ตการลงทุนขั้นสูงทั้งหมด",
    value: "1,797",
    isBonus: true
  },
  {
    item: "Bonus: 500 Tokens พิเศษ",
    detail: "สำหรับใช้ปลดล็อกรายงาน Wealth Report เชิงลึกในระบบ",
    value: "400",
    isBonus: true
  },
  {
    item: "Bonus: สิทธิ์เข้ากลุ่ม Line VIP เฉพาะรุ่น",
    detail: "ปรึกษาและสอบถาม อ.รวิ ได้โดยตรงแม้เรียนจบไปแล้ว",
    value: "2,500",
    isBonus: true
  },
];

export default function ValueStack() {
  return (
    <section className="section-padding bg-white border-b border-zinc-100">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-20">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-zinc-900 text-white mb-6">
            <SafeIcon icon={FiBox} className="w-6 h-6" />
          </div>
          <span className="text-brand-red font-black uppercase tracking-[0.3em] text-xs mb-4 block">Total Value Stack</span>
          <h2 className="text-4xl md:text-5xl font-black text-zinc-900 mb-6 tracking-tight">สรุปมูลค่าที่คุณจะได้รับ</h2>
          <p className="text-zinc-500 font-medium text-lg">รายการทั้งหมดที่จะเปลี่ยนการตัดสินใจทางการเงินของคุณไปตลอดกาล</p>
        </div>

        <div className="bg-white border-[1px] border-zinc-200 shadow-[0_20px_50px_rgba(0,0,0,0.08)] overflow-hidden">
          {/* Table Header */}
          <div className="bg-zinc-900 p-6 flex justify-between items-center text-white">
            <span className="font-black uppercase tracking-[0.2em] text-[10px]">Description / รายการความคุ้มค่า</span>
            <span className="font-black uppercase tracking-[0.2em] text-[10px]">Market Value</span>
          </div>

          <div className="divide-y divide-zinc-100">
            {stack.map((row, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className={`p-8 flex items-start justify-between hover:bg-zinc-50 transition-colors ${row.isMain ? 'bg-zinc-50/50' : 'bg-white'}`}
              >
                <div className="flex gap-5">
                  <div className="mt-1">
                    <SafeIcon icon={FiCheckCircle} className={`w-6 h-6 ${row.isBonus ? 'text-brand-red' : 'text-zinc-900'}`} />
                  </div>
                  <div>
                    <h3 className={`font-black text-xl leading-tight ${row.isBonus ? 'text-zinc-800' : 'text-zinc-900'}`}>
                      {row.item}
                    </h3>
                    <p className="text-zinc-500 text-sm mt-2 font-medium">{row.detail}</p>
                  </div>
                </div>
                <div className="text-right pl-4">
                  <span className="font-black text-2xl text-zinc-900 tabular-nums">{row.value}</span>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Sub Total Section */}
          <div className="p-10 bg-zinc-900 text-white flex flex-col md:flex-row justify-between items-center gap-6 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-red/10 rounded-full blur-3xl -mr-32 -mt-32"></div>
            
            <div className="flex items-center gap-4 relative z-10">
              <div className="w-12 h-12 rounded-full border-2 border-brand-red flex items-center justify-center text-brand-red">
                <SafeIcon icon={FiPlus} className="w-6 h-6" />
              </div>
              <div>
                <span className="text-zinc-400 font-black uppercase tracking-widest text-[10px] block mb-1">Total Package Value</span>
                <span className="text-white font-black text-xl uppercase tracking-widest">รวมมูลค่าทั้งหมดที่คุณได้รับ</span>
              </div>
            </div>

            <div className="text-center md:text-right relative z-10">
              <div className="text-5xl md:text-6xl font-black text-white tracking-tighter">
                <span className="text-brand-red text-2xl font-black mr-3">THB</span>
                24,097
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <div className="inline-block border-2 border-brand-red px-6 py-2">
            <p className="text-brand-red text-sm font-black uppercase tracking-[0.2em]">
              * โบนัสพิเศษมูลค่า 11,197 บาท มอบให้ฟรีเฉพาะรุ่นนี้เท่านั้น
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}